// src/Main.jsx
import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import { ChakraProvider } from '@chakra-ui/react';
import initialTheme from './theme/theme';
import { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext'; // Importa el contexto
import { SearchProvider } from './contexts/SearchContext'; // Importa el contexto de búsqueda
import { LoaderProvider } from './contexts/LoaderContext';

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(initialTheme);

  return (
    <ChakraProvider theme={currentTheme}>
      <AuthProvider>
        <SearchProvider>
          <LoaderProvider>
            <AppRoutes />
          </LoaderProvider>
        </SearchProvider>
      </AuthProvider>
    </ChakraProvider>
  );
}

const AppRoutes = () => {
  const { isAuthenticated } = useAuth(); // Obtén el estado de autenticación

  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
        path="admin/*"
        element={
          isAuthenticated ? (
            <AdminLayout />
          ) : (
            <Navigate to="/auth/sign-in" replace /> // Redirige al login si no está autenticado
          )
        }
      />
      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};
